(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["amedoree-cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    const SECTION_ID = document.querySelector('cart-drawer-component.amedoree-cart-drawer')?.dataset.sectionId;
    if (!SECTION_ID) return;

    // 1. Open drawer when cart trigger anywhere in the page is clicked
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-cart-drawer-trigger]');
      if (!trigger) return;
      e.preventDefault();
      const drawer = document.querySelector('cart-drawer-component.amedoree-cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else if (drawer && typeof drawer.showDialog === 'function') {
        drawer.showDialog();
      }
    });

    // 2. Section Rendering: re-fetch this section's HTML and morph the inner content
    async function refreshDrawer() {
      const root = document.querySelector('.amedoree-cart');
      if (!root) return;
      root.classList.add('is-loading');
      try {
        const res = await fetch('/?sections=' + encodeURIComponent(SECTION_ID), {
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) throw new Error('Section fetch failed: ' + res.status);
        const data = await res.json();
        const html = data[SECTION_ID];
        if (!html) throw new Error('Section HTML missing in response');

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newRoot = doc.querySelector('.amedoree-cart');
        if (!newRoot) throw new Error('New .amedoree-cart not found');

        root.innerHTML = newRoot.innerHTML;
      } catch (err) {
        console.error('[amedoree-cart] refresh failed, falling back to reload:', err);
        window.location.reload();
      } finally {
        const after = document.querySelector('.amedoree-cart');
        if (after) after.classList.remove('is-loading');
      }
    }

    // Refresh the header cart bubble (count + visibility) after any cart change.
    async function refreshCartBubble() {
      try {
        const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (!res.ok) return;
        const cart = await res.json();
        const count = cart.item_count || 0;

        // Strategy 1: Try to invoke Horizon's native cart-icon update method (if exposed)
        const cartIcons = document.querySelectorAll('cart-icon');
        cartIcons.forEach(icon => {
          if (typeof icon.update === 'function') {
            icon.update(cart);
          } else if (typeof icon.refresh === 'function') {
            icon.refresh();
          } else if (typeof icon.render === 'function') {
            icon.render();
          }
        });

        // Strategy 2: Dispatch Horizon's expected events (multiple variants for safety)
        ['cart:update', 'cart:change', 'cart:refresh'].forEach(eventName => {
          document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: { cart, source: 'amedoree-cart' } }));
        });

        // Strategy 3: Manually rewrite the bubble — runs after a delay so Horizon's own logic settles first
        setTimeout(() => {
          const bubbles = document.querySelectorAll('.cart-bubble, [ref="cartBubble"]');
          bubbles.forEach(bubble => {
            bubble.textContent = count > 0 ? count : '';
            if (count > 0) {
              bubble.classList.remove('visually-hidden');
              bubble.removeAttribute('hidden');
              bubble.style.color = '';
              bubble.style.background = '';
            } else {
              bubble.classList.add('visually-hidden');
            }
          });

          // Also update any cart-count spans or [data-cart-count] elements
          const counts = document.querySelectorAll('[data-cart-count], .cart-count');
          counts.forEach(el => {
            el.textContent = count;
          });
        }, 100);
      } catch (err) {
        console.error('[amedoree-cart] bubble refresh failed:', err);
      }
    }

    // Expose globally so the product page (and other components) can trigger a refresh
    window.amedoreeRefreshCart = async function () {
      await refreshDrawer();
      await refreshCartBubble();
    };

    // Listen for cart:updated events from other components — refresh, then open drawer
    document.addEventListener('cart:updated', async function (e) {
      // Skip if the event came from our own drawer to avoid infinite loops
      if (e.detail && e.detail.source === 'amedoree-cart') return;
      await refreshDrawer();
      await refreshCartBubble();
    });

    // Sync bubble on page load in case cart changed in another tab
    refreshCartBubble();

    // 3. Cart actions (delegated, survives re-renders)
    document.addEventListener('click', async function (e) {
      const inc = e.target.closest('[data-quantity-increase]');
      const dec = e.target.closest('[data-quantity-decrease]');
      const rem = e.target.closest('[data-cart-remove]');
      const add = e.target.closest('[data-recs-add]');
      if (!inc && !dec && !rem && !add) return;

      // Only act on actions inside the drawer (avoid hijacking other contexts)
      if ((inc || dec || rem) && !e.target.closest('.amedoree-cart')) return;
      if (add && !e.target.closest('.amedoree-cart')) return;

      e.preventDefault();

      try {
        if (inc || dec || rem) {
          const item = (inc || dec || rem).closest('[data-cart-item]');
          if (!item) return;
          const key = item.dataset.key;
          if (!key) return;
          const currentVal = parseInt(item.querySelector('.ad-cart__quantity-value').textContent, 10);
          let newVal;
          if (inc) newVal = currentVal + 1;
          else if (dec) newVal = Math.max(0, currentVal - 1);
          else newVal = 0;

          const root = document.querySelector('.amedoree-cart');
          if (root) root.classList.add('is-loading');

          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: newVal })
          });
          if (!res.ok) throw new Error('Cart change failed: ' + res.status);
        }

        if (add) {
          const variantId = add.dataset.variantId;
          if (!variantId) return;
          const root = document.querySelector('.amedoree-cart');
          if (root) root.classList.add('is-loading');

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        }

        // Update the cart bubble + any other cart-aware components
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'amedoree-cart' } }));

        await refreshDrawer();
        await refreshCartBubble();
      } catch (err) {
        console.error('[amedoree-cart] action failed:', err);
        window.location.reload();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
